"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var core_1 = require("@material-ui/core");
var react_1 = tslib_1.__importDefault(require("react"));
function Radio(props) {
    var label = props.label, labelPlacement = props.labelPlacement, _a = props.radioPlacement, radioPlacement = _a === void 0 ? 'top' : _a, value = props.value, checkedIcon = props.checkedIcon, color = props.color, _b = props.size, size = _b === void 0 ? 'small' : _b, containerStyle = props.containerStyle, rest = tslib_1.__rest(props, ["label", "labelPlacement", "radioPlacement", "value", "checkedIcon", "color", "size", "containerStyle"]);
    var useStyles = core_1.makeStyles(function () {
        return core_1.createStyles({
            input: {
                alignSelf: radioPlacement === 'top'
                    ? 'flex-start'
                    : radioPlacement === 'bottom'
                        ? 'flex-end'
                        : ''
            }
        });
    });
    var classes = useStyles();
    var theme = core_1.useTheme();
    return (react_1["default"].createElement(core_1.FormControlLabel, { control: react_1["default"].createElement(core_1.Radio, tslib_1.__assign({ checkedIcon: checkedIcon ? (checkedIcon) : (react_1["default"].createElement(core_1.SvgIcon, { fontSize: size === 'small' ? 'small' : 'default' },
                react_1["default"].createElement("circle", { cx: "12", cy: "12", fill: "transparent", r: size === 'medium' ? 7 : 6.5, stroke: color === 'secondary'
                        ? theme.palette.secondary.main
                        : theme.palette.primary.main, strokeWidth: "5" }))), className: classes.input, color: color, size: size }, rest)), label: label, labelPlacement: labelPlacement, style: containerStyle, value: value }));
}
exports["default"] = Radio;
//# sourceMappingURL=Radio.js.map